import * as React from 'react';

// Externals
import { t, Trans } from '@lingui/macro';
import { i18n } from '@lingui/core';
import LocationLabel from './locationLabel';
import { getJobFunctionLabel } from '../../../models/jobFunction';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import RelationStatuses from '../../../helpers/relationStatuses';
import AnonymousModal from '../../relations/components/relationItem/components/anonymousModal';
import CompleteModal from '../../relations/components/relationItem/components/completeModal';
import RejectModal from '../../relations/components/relationItem/components/rejectModal';
import UnlinkModal from '../../relations/components/relationItem/components/unlinkModal';
import Actors from '../../../helpers/actors';
import Modal from '../../../shared/modal';
import SubscriptionLevels from '../../../helpers/subscription/levels';


// Helpers


class JobOfferItemProps {
  id: any;
  jobOffer: any;
  isAnonymous: boolean;
}

class JobOfferItemState {
  showConfirmAccept: boolean;
  showConfirmReject: boolean;
  showConfirmInvite: boolean;
  showConfirmUnlink: boolean;
  showConfirmComplete: boolean;
  showConfirmChatModal: boolean;
  sendMessageAfterInvite: boolean;
  loading: boolean;
  accepted: boolean;
  invited: boolean;
  rejected: boolean;
  linked: boolean;
  unlinked: boolean;
}

export default class JobOfferItem extends React.Component<JobOfferItemProps, JobOfferItemState> {
  constructor(props: JobOfferItemProps) {
    super(props);

    this.state = {
      showConfirmAccept: false,
      showConfirmReject: false,
      showConfirmInvite: false,
      showConfirmUnlink: false,
      showConfirmComplete: false,
      showConfirmChatModal: false,
      sendMessageAfterInvite: false,
      loading: false,
      accepted: false,
      invited: false,
      rejected: false,
      linked: false,
      unlinked: false,
    };
  }
  acceptInvite = async () => {
    this.setState({
      showConfirmAccept: true
    });
  };

  confirmAccept = async () => {
    this.setState({
      showConfirmAccept: false,
      loading: true
    });

    let response = await fetch('/api/relation/accept', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        companyProfileId: this.props.jobOffer.companyProfileId,
        employeeProfileId: this.props.jobOffer.employeeProfileId
      }),
      credentials: 'include'
    });

    this.setState({
      loading: false
    });

    if (response.ok) {
      this.setState({
        accepted: true,
        showConfirmAccept: false
      });
    }
  };

  rejectInvite = async () => {
    this.setState({
      showConfirmReject: true
    });
  };

  link = async () => {
    this.setState({
      loading: true
    });

    let response = await fetch('/api/relation/link', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        companyProfileId: this.props.jobOffer.companyProfileId,
        employeeProfileId: this.props.jobOffer.employeeProfileId
      }),
      credentials: 'include'
    });

    if (response.ok) {
      this.setState({ linked: true });
    }

    this.setState({
      loading: false
    });
  };

  unlink = async () => {
    this.setState({
      showConfirmUnlink: true
    });
  };

  confirmUnlink = async () => {
    this.setState({
      showConfirmUnlink: false,
      loading: true
    });

    let response = await fetch('/api/relation/unlink', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        companyProfileId: this.props.jobOffer.companyProfileId,
        employeeProfileId: this.props.jobOffer.employeeProfileId
      }),
      credentials: 'include'
    });

    if (response.ok) {
      this.setState({ unlinked: true });
    }

    this.setState({
      loading: false,
      showConfirmUnlink: false
    });
  };

  confirmReject = async () => {
    this.setState({
      showConfirmReject: false,
      loading: true
    });

    let response = await fetch('/api/relation/reject', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        companyProfileId: this.props.jobOffer.companyProfileId,
        employeeProfileId: this.props.jobOffer.employeeProfileId
      }),
      credentials: 'include'
    });

    this.setState({
      loading: false
    });

    if (response.ok) {
      this.setState({
        rejected: true,
        showConfirmReject: false
      });
    }
  };

  sendInvite = async () => {

    if (localStorage.getItem('userComplete') === 'false') {
      this.setState({
        showConfirmComplete: true
      });

      return;
    }
    this.setState({
      showConfirmInvite: true
    });
  };

  confirmComplete = () => {
    this.setState({
      showConfirmComplete: false
    });

    window.location.replace('/dashboard/profil');
  };

  confirmInvite = async () => {
    let response = await fetch('/api/relation/invite', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        companyProfileId: this.props.jobOffer.companyProfileId,
        employeeProfileId: this.props.jobOffer.employeeProfileId
      }),
      credentials: 'include'
    });

    this.setState({
      loading: false
    });

    if (response.ok) {
      this.setState({
        invited: true,
        showConfirmInvite: false
      });

      if (this.state.sendMessageAfterInvite) {
        this.startConversation();
      }
    }
  };

  onCancel = () => {
    this.setState({
      showConfirmInvite: false,
      showConfirmComplete: false,
      showConfirmAccept: false,
      showConfirmReject: false,
      showConfirmUnlink: false,
      showConfirmChatModal: false,
      sendMessageAfterInvite: false
    });
  };

  startConversation = () => {
    window.startConversation(this.props.jobOffer.companyProfile.user.id);
  }

  render() {
    const {
      showConfirmAccept,
      showConfirmReject,
      showConfirmInvite,
      showConfirmUnlink,
      showConfirmComplete
    } = this.state;
    return (
      <React.Fragment>
        <div
          className={`profile-card-wrapper`}>
          {this.renderHighlight()}
          {this.renderCompany()}
          {this.renderButtons()}
          {this.renderChatButton()}
        </div>
        {showConfirmInvite && (
          <AnonymousModal onContinue={this.confirmInvite} onCancel={this.onCancel} />
        )}
        {showConfirmComplete && (
          <CompleteModal onContinue={this.confirmComplete} onCancel={this.onCancel} />
        )}
        {showConfirmAccept && (
          <AnonymousModal onContinue={this.confirmAccept} onCancel={this.onCancel} />
        )}
        {showConfirmReject && (
          <RejectModal onContinue={this.confirmReject} onCancel={this.onCancel} />
        )}
        {showConfirmUnlink && (
          <UnlinkModal
            onContinue={this.confirmUnlink}
            onCancel={this.onCancel}
            actor={Actors.Employee}
          />
        )}
      </React.Fragment>
    );
  }

  renderHighlight() {
    const { jobOffer } = this.props;
    const company = jobOffer.companyProfile;

    let hasMaxi = false;
    if (company.user && company.user.stripeSubscriptionLevel === SubscriptionLevels.MAXI) {
      hasMaxi = true;
    }
    
    if (company.isHighlighted || hasMaxi) {
      return (
        <div className="ribbon ribbon-top-left">
          <span>
            <Trans>URGENT</Trans>
          </span>
        </div>
      );
    }
  }

  renderCompany() {
    let { jobOffer } = this.props;

    const company = jobOffer.companyProfile;

    return (
      <React.Fragment>
        <div className="profile-card-infos-wrapper">
          <div className="d-flex flex-column">
            <div
              className="profile-card-fonction text-truncate"
              style={jobOffer.jobFunction ? {
                color: '#1468b3',
                fontWeight: 'bold',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                margin: '0px 0px 15px 0px',
                display: 'block',
              } : { 
                color: '#333', 
                fontWeight: 'bold', 
                margin: '0px 0px 15px 0px', 
                textOverflow: 'ellipsis', 
                whiteSpace: 'normal' 
              }}
            >
              <p style={{
                margin: 0,
                display: 'block',
                lineHeight: '1.2em',
                height: '2.4em',
                overflow: 'hidden',
              }}>
                {getJobFunctionLabel(jobOffer.jobFunction, i18n.locale) || getJobFunctionLabel(company.jobFunction, i18n.locale)}
              </p>
            </div>
            <div
              className="profile-card-image-container"
              style={{
                backgroundImage: `url(${company.picture || '/images/Avatar_rectangle.jpg'})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}></div>
          </div>
          <div className="profile-card-infos-container">
            <div className="profile-card-name text-truncate">{company.companyName}</div>
            <div className="profile-card-fonction text-truncate">
              {company.firstName ? company.firstName + ' ' : ''}
              {company.lastName ? company.lastName + ' ' : ''}
            </div>
            <div className="profile-card-fonction text-truncate">
              <LocationLabel hideName location={jobOffer.jobOfferLocation || company.companyAddressLocation} />
            </div>
            <>
              {company.email && (
                <div className="profile-card-name text-truncate">
                  <i className="fas fa-eveloppe fa-lg"></i>
                  <a
                    href={
                      `mailto:${company.email}?subject=` +
                      t`Candidature consécutive à votre offre d’emploi sur syndy`
                    }>
                    {company.email}
                  </a>
                </div>
              )}
              {company.contactPersonEmail && company.email !== company.contactPersonEmail && (
                <div className="profile-card-name text-truncate">
                  <i className="fas fa-eveloppe fa-lg"></i>
                  <a
                    href={
                      `mailto:${company.contactPersonEmail}?subject=` +
                      t`Candidature consécutive à votre offre d’emploi sur syndy`
                    }>
                    {company.contactPersonEmail}
                  </a>
                </div>
              )}
              <div className="divider profile-card"></div>
              <div className="profile-card-socials-wrapper">
                {company.website ? (
                  <a href={company.website} className="link-block-socials w-inline-block">
                    <i className="fas fa-globe fa-lg"></i>
                  </a>
                ) : (
                  <div className="link-block-socials w-inline-block text-disabled cursor-not-allowed">
                    <i className="fas fa-globe fa-lg"></i>
                  </div>
                )}
                {company.linkedin ? (
                  <a href={company.linkedin} className="link-block-socials w-inline-block">
                    <div className="icon icon-linkedin"></div>
                  </a>
                ) : (
                  <div className="link-block-socials w-inline-block text-disabled cursor-not-allowed">
                    <div className="icon icon-linkedin"></div>
                  </div>
                )}
                {company.facebook ? (
                  <a href={company.facebook} className="link-block-socials w-inline-block">
                    <div className="icon icon-facebook"></div>
                  </a>
                ) : (
                  <div className="link-block-socials w-inline-block text-disabled cursor-not-allowed">
                    <div className="icon icon-facebook"></div>
                  </div>
                )}
                {company.twitter ? (
                  <a href={company.twitter} className="link-block-socials w-inline-block">
                    <div className="icon icon-twitter"></div>
                  </a>
                ) : (
                  <div className="link-block-socials w-inline-block text-disabled cursor-not-allowed">
                    <div className="icon icon-twitter"></div>
                  </div>
                )}
                {company.instagram ? (
                  <a href={company.instagram} className="link-block-socials w-inline-block">
                    <div className="icon icon-instagram"></div>
                  </a>
                ) : (
                  <div className="link-block-socials w-inline-block text-disabled cursor-not-allowed">
                    <div className="icon icon-instagram"></div>
                  </div>
                )}
              </div>
            </>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderButtons() {
    let { jobOffer } = this.props;

    let { accepted, invited, rejected } = this.state;

    const { status, createdBy, actor } = jobOffer;

    if (jobOffer.isJobOffer) {
      return (
        <div className="profile-card-buttons-wrapper">
          <div className="profile-card-buttons-cotnainer">
            <a
              href={`/dashboard/jobs/${jobOffer.id}`}
              style={{ backgroundColor: '#1468b3' }}
              className="button solid right-cap w-inline-block mx-0"
              id={`check-${this.props.id}`}>
              <Trans>Voir l'offre</Trans>
            </a>
          </div>
        </div>
      );
    }

    if ((status === RelationStatuses.Pending && createdBy === Actors.Employee) || invited) {
      return (
        <div className="profile-card-buttons-wrapper">
          <div className="profile-card-buttons-cotnainer">
            <button type="button" disabled className="button solid grey w-inline-block mx-0">
              <span>
                <Trans>Invitation envoyée</Trans>
              </span>
            </button>
          </div>
        </div>
      );
    }

    if (status === RelationStatuses.Accepted) {
      return (
        <div className="profile-card-buttons-wrapper">
          <div className="profile-card-buttons-cotnainer">
            <button
              id={`connected-${this.props.id}`}
              type="button"
              disabled={true}
              className="button solid left-cap grey w-inline-block ml-0 mr-1">
              <span>
                <Trans>Connecté</Trans>
              </span>
            </button>
            <button
              onClick={this.unlink}
              id={`unlink-${this.props.id}`}
              type="button"
              className="button solid right-cap orange w-inline-block mr-0">
              <img
                src="/images/Cancel_White.svg"
                width="19"
                alt=""
                className="icon-button-profile-card"
              />
            </button>
            <UncontrolledPopover
              placement="bottom"
              target={`unlink-${this.props.id}`}
              trigger="hover">
              <PopoverBody>
                <p className="m-1">
                  {t`Supprimer cet employeur de mon réseau.`}
                </p>
              </PopoverBody>
            </UncontrolledPopover>
          </div>
        </div>
      );
    }

    if (accepted) {
      return (
        <div className="profile-card-buttons-wrapper">
          <div className="profile-card-buttons-cotnainer">
            <button type="button" disabled className="button solid grey w-inline-block mx-0">
              <span>
                <Trans>Invitation acceptée</Trans>
              </span>
            </button>
          </div>
        </div>
      );
    }

    if (status === RelationStatuses.Rejected) {
      return (
        <div className="profile-card-buttons-wrapper">
          <div className="profile-card-buttons-cotnainer">
            <button
              id={`connected-${this.props.id}`}
              type="button"
              disabled={true}
              className="button solid left-cap grey w-inline-block ml-0 mr-1">
              <span>
                <Trans>Invitation refusée</Trans>
              </span>
            </button>
            <button
              onClick={this.link}
              id={`link-${this.props.id}`}
              type="button"
              className="button solid right-cap color-accent-2 w-inline-block mr-0">
              <img src="/images/check.svg" width="19" alt="" className="icon-button-profile-card" />
            </button>
            <UncontrolledPopover
              placement="bottom"
              target={`link-${this.props.id}`}
              trigger="hover">
              <PopoverBody>
                <p className="m-1">
                  {t`Intégrer cet employeur à mon réseau.`}
                </p>
              </PopoverBody>
            </UncontrolledPopover>
          </div>
        </div>
      );
    }

    if (rejected) {
      return (
        <div className="profile-card-buttons-wrapper">
          <div className="profile-card-buttons-cotnainer">
            <button type="button" disabled className="button solid grey w-inline-block mx-0">
              <span>
                <Trans>Invitation refusée</Trans>
              </span>
            </button>
          </div>
        </div>
      );
    }

    if (status === RelationStatuses.Draft || status === RelationStatuses.Deleted) {
      return (
        <div className="profile-card-buttons-wrapper">
          <div className="profile-card-buttons-cotnainer">
            <a
              href="#"
              className="button solid color-accent-2 w-inline-block mx-0"
              onClick={this.sendInvite}>
              <i className="fas fa-user-plus"></i>
              <span className="ml-2">
                <Trans>Se connecter</Trans>
              </span>
            </a>
          </div>
        </div>
      );
    }

    return (
      <div className="profile-card-buttons-wrapper">
        <div className="profile-card-buttons-cotnainer">
          <a
            href="#"
            className="button outline left-cap grey w-inline-block"
            onClick={this.rejectInvite}
            id={`cancel-${this.props.id}`}>
            <img src="/images/Cancel.svg" width="24" alt="" className="icon-button-profile-card" />
          </a>
          <UncontrolledPopover
            placement="bottom"
            target={`cancel-${this.props.id}`}
            trigger="hover">
            <PopoverBody>
              <p className="m-1">
                <Trans>Refuser l'invitation</Trans>
              </p>
            </PopoverBody>
          </UncontrolledPopover>
          <a
            href="#"
            className="button solid right-cap color-accent-2 w-inline-block"
            onClick={this.acceptInvite}
            id={`check-${this.props.id}`}>
            <img src="/images/check.svg" width="24" alt="" className="icon-button-profile-card" />
          </a>
          <UncontrolledPopover placement="bottom" target={`check-${this.props.id}`} trigger="hover">
            <PopoverBody>
              <p className="m-1">
                <Trans>Intégrer le candidat dans mon réseau pour accéder à ses coordonnées</Trans>
              </p>
            </PopoverBody>
          </UncontrolledPopover>
        </div>
      </div>
    );
  }

  renderChatButton = () => {
    const { jobOffer } = this.props;
    const canContactCompanies = sessionStorage.getItem('canContactCompanies') === 'true';

    const onSendMessage = () => {
      // If the user is anonymous and the job offer is not pending, accepted
      // and we did not just sent an invite or accepted the invite
      if (this.props.isAnonymous &&
        jobOffer.status !== RelationStatuses.Pending &&
        jobOffer.status !== RelationStatuses.Accepted &&
        !this.state.accepted &&
        !this.state.invited) {
        // then we show the confirmation modal
        this.setState({ showConfirmChatModal: true });
      } else {
        // otherwise we start the conversation
        this.startConversation();
      }
    }

    return (
      <>
        {canContactCompanies ? (
          <button
            className="button solid color-accent-1 w-inline-block mx-0 mt-0"
            onClick={onSendMessage}
          >
            <Trans>Envoyer un message</Trans>
          </button>
        ) : (
          <>
            <button
              type="button"
              disabled
              id={`send-message-button-${this.props.id}`}
              className="button solid grey w-inline-block mx-0 mt-0"
            >
              <i className="fas fa-lock"></i>
              <span className="ml-2">
                <Trans>Envoyer un message</Trans>
              </span>
            </button>
            <UncontrolledPopover
              placement="bottom"
              target={`send-message-button-${this.props.id}`}
              trigger="hover">
              <PopoverBody>
                <p className="m-1">
                  <Trans>Vous devez compléter votre profil pour pouvoir contacter un employeur.</Trans>
                </p>
              </PopoverBody>
            </UncontrolledPopover>
          </>
        )}

        {this.state.showConfirmChatModal && (
          <Modal onClose={() => this.setState({ showConfirmChatModal: false })}>
            <div style={{ padding: '35px 20px', paddingBottom: 0 }}>
              <p>
                <Trans>Vous êtes actuellement anonyme. Pour envoyer un message à cet employeur, vous devez l'inviter dans votre réseau.</Trans>
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button
                  className="button solid color-accent-1"
                  onClick={async () => {
                    this.setState({
                      showConfirmChatModal: false,
                      showConfirmInvite: true,
                      sendMessageAfterInvite: true
                    });
                  }}
                >
                  <Trans>Envoyer une invitation</Trans>
                </button>
                <button className="button outline" onClick={this.onCancel}>
                  <Trans>Annuler</Trans>
                </button>
              </div>
            </div>
          </Modal>
        )}
      </>
    );
  };
}